import { ActionTypes } from "../constants/Types";
const initialState = {
  forgotPasswordEmail: null,
  verificationEmail: null,
  verificationId: null,
};

export const tempStorageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FORGOT_PASSWORD_EMAIL:
      return { ...state, forgotPasswordEmail: action.payload };
    case ActionTypes.VERIFICATION_EMAIL:
      return { ...state, verificationEmail: action.payload };  
    case ActionTypes.VERIFICATION_ID:
      return { ...state, verificationId: action.payload };  
    case ActionTypes.CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};
